import { callPlanet } from './'

export const fetchNavigationRedirectMobile = (marketId, memberId) => {
  const headers = {
    'X-Vp-Mid': memberId,
    'X-Vp-Msite': marketId
  }

  return callPlanet('/nav/v1.0/searchTools/mobile/redirect', undefined, headers)
}
